import AdminNumerolojiMeditation from "@/pages/AdminNumerolojiMeditation";

export default function AdminNumerolojiBreath() {
  return <AdminNumerolojiMeditation mode="breath" />;
}
